export const iconFontAwesomeTravelHotelSnowplow = (
	<i className="fa-solid fa-snowplow"></i>
);
